import { IGlobalSettingsState } from '../../../types'
import { IGlobalSettingsAction } from '../../actions/global-settings'
import * as constants from '../../constants'

const initState = {
  serviceLevels: {
    fetching: false,
    items: {}
  }
}

export function globalSettings(state: IGlobalSettingsState, action: IGlobalSettingsAction): IGlobalSettingsState {
  if (typeof state === 'undefined') {
    return initState
  }
  switch (action.type) {
    case constants.GS_FETCH_SERVICE_LEVELS_REQUEST: {
      const serviceLevels = { ...state.serviceLevels, fetching: true }
      return Object.assign({}, state, {
        serviceLevels
      })
    }
    case constants.GS_FETCH_SERVICE_LEVELS_SUCCESS: {
      const items = {}
      action.payload.forEach(i => (items[i.id] = i))
      const serviceLevels = {
        ...state.serviceLevels,
        fetching: false,
        items
      }
      return Object.assign({}, state, {
        serviceLevels
      })
    }
    case constants.GS_CREATE_SERVICE_LEVEL_SUCCESS: {
      const items = {}
      items[action.payload.id] = action.payload
      const serviceLevels = {
        ...state.serviceLevels,
        fetching: false,
        items
      }
      return Object.assign({}, state, {
        serviceLevels
      })
    }
  }

  return state
}



// WEBPACK FOOTER //
// ./src/state/reducers/global-settings/index.ts